import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  ticket: {
    display: 'flex',
    gap: '16px',
    width: '100%',
    height: '70px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_50.main,
    borderRadius: '8px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.blue_50.main
    },
    padding: '4px 10px',
    overflow: 'hidden'
  },

  pendingTicket: {
    cursor: 'unset'
  },

  listItemText: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',

  },
  listItemAvatar: {
    width: '40px',
    height: '40px',
    minWidth: '40px'
  },

  contactNameWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontWeight: '600',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
  },

  contactName: {
    width: '100%',
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },

  lastMessageTime: {
    display: 'flex',
    // justifyContent: 'flex-end',
    fontSize: '12px',
    fontWeight: '400',
    color: theme.palette.gray_400.main
  },

  closedBadge: {
    alignSelf: 'center',
    justifySelf: 'flex-end',
    marginRight: 32,
    marginLeft: 'auto'
  },

  contactLastMessage: {
    paddingRight: 20
  },

  contactMessage: {
    display: 'flex',
    width: '100%'
  },

  newMessagesCount: {
    alignSelf: 'center',
    marginRight: 8,
    marginLeft: 'auto'
  },

  badgeStyle: {
    color: theme.palette.white_100.main,
    backgroundColor: theme.palette.green_200.main,
    position: 'relative',
    top: 34,
    left: -25
  },

  acceptButton: {
    position: 'absolute',
    left: '50%'
  },

  ticketQueueWrapper: {
    '& span': {
      fontWeight: '400',
      fontSize: '10px',
      textTransform: 'uppercase',
      borderRadius: '4px',
      color: theme.palette.white_100.main
    }
  },

  ticketQueueColor: {
    flex: 'none',
    width: '8px',
    height: '100%',
    padding: '2px 8px'
    // position: "absolute",
    // top: "0%",
    // left: "0%",
  }
}))